"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _toConsumableArray2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _order = require("@/api/order");
var _vuePropertyDecorator = require("vue-property-decorator");
var _Export2Excel = require("@/vendor/Export2Excel");
var _orderExcel = require("./order-excel");
var ExportModal = /*#__PURE__*/function (_Vue) {
  function ExportModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ExportModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ExportModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "ordersExport", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {});
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "colsExport", []);
    (0, _defineProperty2.default)(_this, "visible", false);
    return _this;
  }
  (0, _inherits2.default)(ExportModal, _Vue);
  return (0, _createClass2.default)(ExportModal, [{
    key: "fetchOrderExport",
    value: function () {
      var _fetchOrderExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = (0, _objectSpread2.default)({}, this.query);
              delete query.page;
              delete query.limit;
              _context.next = 5;
              return _order.orderApi.findAll(query);
            case 5:
              res = _context.sent;
              this.ordersExport = res.data.orders;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchOrderExport() {
        return _fetchOrderExport.apply(this, arguments);
      }
      return fetchOrderExport;
    }()
  }, {
    key: "fetchOrdersAndGiveawayExport",
    value: function () {
      var _fetchOrdersAndGiveawayExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _res$data$orders;
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = (0, _objectSpread2.default)({}, this.query);
              delete query.page;
              delete query.limit;
              _context2.next = 5;
              return _order.orderApi.findOrdersAndGiveaway(query);
            case 5:
              res = _context2.sent;
              this.ordersExport = (_res$data$orders = res.data.orders).concat.apply(_res$data$orders, (0, _toConsumableArray2.default)(res.data.giveaways));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchOrdersAndGiveawayExport() {
        return _fetchOrdersAndGiveawayExport.apply(this, arguments);
      }
      return fetchOrdersAndGiveawayExport;
    }()
  }, {
    key: "handleView",
    value: function handleView(query) {
      this.query = query;
      this.visible = true;
    }
  }, {
    key: "exportExcel",
    value: function () {
      var _exportExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(type) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.loadingExcel = true;
              _context3.next = 3;
              return this.fetchOrderExport();
            case 3:
              this.loadingExcel = false;
              (0, _orderExcel.exportOrderExcel)({
                data: this.ordersExport,
                type: type
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function exportExcel(_x) {
        return _exportExcel.apply(this, arguments);
      }
      return exportExcel;
    }()
  }, {
    key: "exportExcelReal",
    value: function exportExcelReal() {
      this.exportExcel("real");
    }
  }, {
    key: "exportExcelAccountant",
    value: function exportExcelAccountant() {
      this.exportExcel("accountant");
    }
  }, {
    key: "exportDeliveryExcel",
    value: function () {
      var _exportDeliveryExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.loadingExcel = true;
              _context4.next = 3;
              return this.fetchOrderExport();
            case 3:
              this.loadingExcel = false;
              (0, _Export2Excel.export_table_to_excel)("#order-delivery-excel-table", "Order Delivery");
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function exportDeliveryExcel() {
        return _exportDeliveryExcel.apply(this, arguments);
      }
      return exportDeliveryExcel;
    }()
  }, {
    key: "exportOrdersAndGiveawayExcel",
    value: function () {
      var _exportOrdersAndGiveawayExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.loadingExcel = true;
              _context5.next = 3;
              return this.fetchOrdersAndGiveawayExport();
            case 3:
              this.loadingExcel = false;
              (0, _Export2Excel.export_table_to_excel)("#order-giveaway-excel-table", "Order Giveaway");
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function exportOrdersAndGiveawayExcel() {
        return _exportOrdersAndGiveawayExcel.apply(this, arguments);
      }
      return exportOrdersAndGiveawayExcel;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
ExportModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({})], ExportModal);
var _default = exports.default = ExportModal;